<template>
  <div class="page1">
    <ETable :tableTitle="tableTitle" :tableData="tableData" :needPagination="false">
      <el-table-column fixed="right" label="公众号授权" width="130px">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="editDialog(scope.row)">授权</el-button>
          </div>
        </template>
      </el-table-column>
    </ETable>
    <EDialog :dialogVisible="dialogVisible" :title="title" @handleClose="handleClose" width="50%"
      @handleClick="saveData">
      <el-form label-position="right" label-width="150px" :model="form" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="部门名称" prop="deptName">
              <el-input v-model="form.deptName" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="公众号模块" prop="moduleNames">
              <el-select v-model="detpModules" multiple placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in modules" :key="item.id" :label="item.moduleName"
                  :value="item.moduleName">
                  <span style="float: left;">{{ item.moduleName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px; margin-right: 20px;">{{
                    item.moduleKey}}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </EDialog>
  </div>
</template>

<script>
import ETable from '@/components/ETable'
import Http from "@/service/http";
import EDialog from '@/components/EDialog'
import EButton from '@/components/EButton'
import EForm from '@/components/EForm'
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      tableTitle: [
        {
          label: '部门名称',
          prop: 'deptName',
          width: '150px'
        },
        {
          label: '授权模块',
          prop: 'fullName'
        }
      ],
      tableData: [],
      loading: false,
      dialogVisible: false,
      title: '添加信息',
      form: {},
      value: '',
      modules: [],
      detpModules:[],
      row:{}
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {},
  created() {
    this.getData()
    this.getModuleList()
  },
  components: { ETable, EDialog, EButton, EForm },
  beforeMount() {

  },
  methods: {
    handleClose() {
      this.title = '添加信息'
      this.dialogVisible = false
      this.form = {}
    },
    async getData() {
      let that = this
      let res = await Http.deptList()
      if (res.code == 200) {
        that.tableData = res.data
        if(that.tableData!=null&&that.tableData.length>0){
          let dept = null;
          let deptName = null;
          for(let i=0; i<that.tableData.length; i++){
            deptName = that.tableData[i].deptName
            dept = {'deptName': deptName}
            let res1 = await Http.deptModuleList(dept)
            
            if (res1.code == 200) {
              if (res1.data.moduleName != null)
                that.tableData[i].fullName = res1.data.moduleName
              else
                that.tableData[i].fullName = "-"
            }else{
              that.tableData[i].fullName = ""
            }
          }
          console.log(that.tableData)
        }
      }

    },
    async getModuleList() {
      let res = await Http.moduleList(this.searchForm)
      if (res.code == 200) {
        this.modules = res.data
        //console.log(this.modules)
      }
    },
    async getDeptModuleList() {
      let res = await Http.deptModuleList(this.form)
      if (res.code == 200) {
        if (res.data.moduleName != null)
          this.detpModules = res.data.moduleName.split(",")
        else
          this.detpModules = []
      }
    },
    saveData() {
      let flag = false
      this.$refs['form'].validate((valid, object) => {
        if (valid && !this.error) {
          flag = true
        } else {
          return false;
        }
      });
      if (flag) {
        this.addBtn()
      }
    },
    getModuleKey(moduleName) {
      for (let i = 0; i < this.modules.length; i++) {
        if (this.modules[i].moduleName === moduleName) {
          return this.modules[i].moduleKey
        }
      }
    },
    async addBtn() {
      let paramModuleName = ""
      let paramModuleKey = ""
      let param = {}
      param.deptName = this.form.deptName
      if (this.detpModules != null && this.detpModules.length > 0) {
        for (let i = 0; i < this.detpModules.length; i++) {
          if (i == 0) {
            paramModuleName = this.detpModules[i]
            paramModuleKey = this.getModuleKey(this.detpModules[i])
          } else {
            paramModuleName = paramModuleName + "," + this.detpModules[i]
            paramModuleKey = paramModuleKey + "," + this.getModuleKey(this.detpModules[i])
          }
        }
      }
      param.moduleName = paramModuleName
      param.moduleKey = paramModuleKey

      let res = await Http.setDeptModules(param)
      //console.log(JSON.stringify(res))
      if (res.code == 200) {
        this.$message.success(res.msg)
        this.handleClose()
        this.row.fullName = param.moduleName
        //this.getData()
      } else {
        this.$message.success(res.msg)
        //this.getData()
      }
    },
    editDialog(data) {
      this.title = '部门授权'
      this.form = data
      this.dialogVisible = true

      this.row = data

      this.getDeptModuleList()
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #DCDFE6;
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;

}
</style>
